SNI.Application.addModule('tags', function(context) {

  return {
    behaviors: ['truncate']
  };

});